import jsonToFormData from 'json-form-data'

function User(axios, baseUrl) {

    this.axios = axios;
    this.baseUrl = `${baseUrl}user`;

    this.get = function (id) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/${id}`);
    }
    this.userProfile = function (userId) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/UserProfile/${userId}`);
    }
    this.filterByName = function (name) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/FilterByName/${name}`);
    }
    this.attendendsList = function () {
        let self = this;
        return self.axios.get(`${self.baseUrl}/AttendendsList`);
    }
    this.profesorsList = function () {
        let self = this;
        return self.axios.get(`${self.baseUrl}/ProfesorsList`);
    }
    this.filter = function (filter) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/Filter/${filter.SelectedPage}/${filter.IsActive}/${filter.SelectedInstrument}/${filter.SelectedRole}`);
    }
    this.filterNoActivity = function (filter) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/FilterNoActivity/${filter.SelectedPage}/${filter.SelectedInstrument}/${filter.SelectedRole}`);
    }
    this.add = function (model) {
        let self = this;
        return self.axios.post(`${self.baseUrl}`, model);
    }
    this.update = function (model) {
        let self = this;
        return self.axios.put(`${self.baseUrl}`, model);
    }
    this.changeUsername = function (userId, username) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/ChangeUsername/${userId}/${username}`);
    }
    this.changePassword = function (userId, oldPassword, newPassword) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/ChangePassword/${userId}/${oldPassword}/${newPassword}`);
    }
    this.resetPassword = function (userId) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/ResetPassword/${userId}`);
    }
    this.changeProfile = function (user, file) {
        let self = this;
        var formData = new FormData();
        formData = jsonToFormData(user);
        if (file != undefined) {
            formData.append(file.name, file);
        }
        return self.axios.post(`${self.baseUrl}/ChangeProfile`, formData);
    }
    this.remove = function (id) {
        let self = this;
        return self.axios.delete(`${self.baseUrl}/${id}`);
    }

    this.getStudentsByProfessor = function (profesorId) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/ProfessorsStudents/${profesorId}`);
    }

    this.addStudentToProfessor = function (profesorId, studentId) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/AddStudentToProfessor/${profesorId}/${studentId}`);
    }

    this.removeStudentFromProfessor = function (profesorId, studentId) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/RemoveStudentFromProfessor/${profesorId}/${studentId}`);
    }
}

export default User